import { PropsWithChildren } from 'react';
import { HeroUIProvider, ToastProvider } from '@heroui/react';

// Интерфейс английский: локаль задаёт форматы дат и служебные подписи внутри HeroUI,
// с uk-UA скринридер читал их по украинским правилам.
export const ThemeProvider = ({ children }: PropsWithChildren) => (
  <HeroUIProvider locale="en-GB">
    <ToastProvider placement="top-right" toastOffset={10} />
    {children}
  </HeroUIProvider>
);
